import API_GATEWAY from "@/services/config/main-axios";

const userService = {
  getAllUsers(filters) {
    return API_GATEWAY.get("user-profile/admin/userInfo/index", {
      params: filters
    });
  },

  getUserNames(filters) {
    return API_GATEWAY.get("user-profile/admin/userInfo/usernames", {
      params: filters
    });
  },

  getUser(userId) {
    return API_GATEWAY.get(`user-profile/admin/userInfo/${userId}`);
  },

  getUserAsset(userId) {
    return API_GATEWAY.get(
      `user-account/admin/account/user/asset/detail/${userId}`
    );
  },

  activateUser(userData) {
    return API_GATEWAY.post("user-profile/admin/userInfo/active", userData);
  },

  deactivateUser(userData) {
    return API_GATEWAY.post("user-profile/admin/userInfo/disable", userData);
  }
};

export default userService;
